<template>

  <div class="flex white_th" style="padding-left: 24px">
    <div class="left">
      <div>
        <Select v-model="projectFid" class="select-width mb16" placeholder="请选择项目" @on-change="getNeedToDoNum">
          <Option v-for="(item,index) in projectList" :key="'project'+index" :value="item.value">{{item.text}}</Option>
        </Select>
        <a @click="toSaleConsole" style="position: relative; top: -7px; left: 20px" v-p="{api:['outHouse/marketingCtrlOverView', 'outHouse/marketingCtrlVacant']}">查看销控台</a>
      </div>
      <div>
        <h3 class="mb16 mt12">待办</h3>
        <RadioGroup v-model="needDo" type="button" size="large" style="display: flex;text-align: center;" class="mb8">
          <Radio v-p="{api:'business/list'}" label="商机" class="flexauto">商机({{sjNum}})</Radio>
          <Radio v-p="{api:'idelHouseRemind/getList'}" label="有房提醒" class="flexauto">有房提醒({{yfNum}})</Radio>
          <Radio v-p="{api:['houseInfo/getVacancyForRentList', 'contract/getContractEndList']}" label="待租" class="flexauto">待租({{dzNum}})</Radio>
          <Radio v-p="{api:'renewagreement/getRenewIntentionList'}" label="续约" class="flexauto">续约({{xyNum}})</Radio>
          <Radio v-p="{api:'certificate/getReceiveList'}" label="回款" class="flexauto">回款({{hkNum}})</Radio>
          <Radio  label="成本报销" class="flexauto">成本报销({{cbNum}})</Radio>
        </RadioGroup>
        <div class="noborder">
          <div>
            <Bussiness v-p="{api:'business/list'}" :projectFid="projectFid" v-if="needDo==='商机'" class="mb16 border"
                       @refreshTotalNum="refreshTotalNum"></Bussiness>
            <HouseRemind v-p="{api:'idelHouseRemind/getList'}" :projectFid="projectFid" v-if="needDo==='有房提醒'"
                     class="mb16 border pb" @refreshTotalNum="refreshTotalNum"></HouseRemind>
            <ForRent v-p="{api:['houseInfo/getVacancyForRentList', 'contract/getContractEndList']}" :projectFid="projectFid" v-if="needDo==='待租'"
                     class="mb16 border pb"></ForRent>
            <Renew v-p="{api:'renewagreement/getRenewIntentionList'}" :projectFid="projectFid" v-if="needDo==='续约'"
                   class="mb16 border pb" @refreshTotalNum="refreshTotalNum"></Renew>
            <Receive v-p="{api:'certificate/getReceiveList'}" :projectFid="projectFid" v-if="needDo==='回款'"
                     class="mb16 border pb" @refreshTotalNum="refreshTotalNum"></Receive>

            <Cost  v-p="{api:'waterwatt/ordinary/reading/list'}" :projectFid="projectFid" v-if="needDo==='成本报销'"
                     class="mb16 border pb" @refreshTotalNum="refreshTotalNum"></Cost>

          </div>
          <Customer v-p="{api:['workbench/getPersonVisitLogList','workbench/birthdayRemind']}" :projectFid="projectFid"
                    class="border "></Customer>
        </div>
      </div>

    </div>
    <div class="right">
      <div>
        <div v-p="{api:'workbench/taskreminder'}">
          <h3 class="mb16">任务提醒</h3>
          <div class="worktodo">
            <TaskReminder :projectFid="projectFid"></TaskReminder>
          </div>
        </div>
        <!-- <div v-p="{api:['workbench/querySaleKanBanCount','workbench/queryFlowRateAndCheckInRate','workbench/queryAnswerRate']}">
          <h3 class="mb16 mt36">销售看板</h3>
          <Sales :projectFid="projectFid" v-if="projectFid" style="border: 1px solid #DFDFDF;"></Sales>
        </div> -->
      </div>

    </div>
  </div>

</template>

<script>
  import Bussiness from './bussiness/index'
  import Customer from './components/Customer'
  // import Sales from './components/Sales.vue'
  import TaskReminder from './components/TaskReminder'
  import ForRent from './forRent/index'
  import Renew from './renew/index'
  import Receive from './receive/index'
  import Cost from './cost/index'
  import {getProjects} from "../../api/common";
  import {getNeedToDoNum} from "api/business"
  import HouseRemind from './houseRemind/index'

  export default {
    name: "workbench",
    mounted(){
      const apiList=this.$store.getters.apiList
      if(apiList.indexOf('business/list')!==-1){
        this.needDo='商机'
        return
      }
      if(apiList.indexOf('idelHouseRemind/getList')!==-1){
        this.needDo='有房提醒'
        return
      }
      if(apiList.indexOf('houseInfo/getVacancyForRentList')!==-1){
        this.needDo='待租'
        return
      }
      if(apiList.indexOf('renewagreement/getRenewIntentionList')!==-1){
        this.needDo='续约'
        return
      }
      if(apiList.indexOf('certificate/getReceiveList')!==-1){
        this.needDo='回款'
        return
      }
      if(apiList.indexOf('cost/getReceiveList')!==-1){
        this.needDo='成本报销'
        return
      }
    },
    components: {
      Bussiness,
      TaskReminder,
      Customer,
      ForRent,
      Renew,
      // Sales,
      Receive,
      HouseRemind,
      Cost
    },
    data() {
      return {
        needDo: '',
        projectFid: '',
        projectList: [],
        sjNum: 0,
        dzNum: 0,
        xyNum: 0,
        hkNum: 0,
        yfNum: 0,
        cbNum: 0,
        answerRateData: [{
          name: '入住率',
          quantity: 8,
          value: 0.8
        }, {
          name: 'test',
          quantity: 2,
          value: 0.2
        }],
      }
    },
    methods: {
      getNeedToDoNum() {
        if (!this.projectFid) {
          return
        }
        const params = {
          projectFid: this.projectFid
        }
        getNeedToDoNum(params).then(res => {
          if (!res.data) {
            return
          }

          res.data.forEach((ele) => {
            if (ele.schedule == 0) {
              this.sjNum = ele.number
            } else if (ele.schedule == 1) {
              this.dzNum = ele.number
            } else if (ele.schedule == 2) {
              this.xyNum = ele.number
            } else if (ele.schedule == 3) {
              this.hkNum = ele.number
            }else if (ele.schedule == 4) {
              this.yfNum = ele.number
            }else if (ele.schedule == 5) {
              this.cbNum = ele.number
            }
          })
        }).catch(() => {
          return
        })
      },
      refreshTotalNum() {
        this.getNeedToDoNum()
      },
      toSaleConsole() {
        const id = this.projectFid
        if(id == null||id==""){
                  this.$Message.error('请选择项目')
                  return;
              }
        this.$router.push({ name: 'mobile', params: {id}})
      }
    },
    created() {
      getProjects().then(res => {
        this.projectList = res.data
        this.projectList.length && (this.projectFid = this.projectList[0].value)
      })

    }
  }
</script>

<style scoped>
  .worktodo {
    background-color: white;
    border: 1px solid #DFDFDF;
    padding: 10px 20px;
  }

  .need-do .flexauto {
    padding: 12px 0;
    text-align: center;
    margin-left: -1px;
  }

  .need-do .flexauto:first-child {
    margin-left: 0px;

  }

  .main {
    width: 100%;
    box-sizing: border-box;
  }

  h3 {
    font-size: 14px;
    line-height: 1;
    vertical-align: top;
  }

  h3::before {
    content: ' ';
    width: 3px;
    background-color: #CFA868;
    display: inline-block;
    vertical-align: top;
    margin-right: 6px;
    height: 14px;
  }

  .right {
    flex: 0 0 472px;
  }

  .left {
    padding: 40px 22px 40px 0;
    flex: 1;
    min-width: 10px;
  }

  .mission-manage {
    max-height: 500px;
    overflow: auto;
    background-color: lightpink;
  }

  .select-width {
    width: 250px;
  }

  .active {
    background: #FFFFFF;
    border: 1px solid #CFA868;
    color: #CFA868;
    z-index: 10;
  }

  .border {
    border: 1px solid #DFDFDF;

  }

  .pb {
    padding-bottom: 20px;
  }

  .right > div {
    background: #eeeeee;
    padding: 44px 20px 20px 20px;
  }

</style>
